import React from 'react';
import CardBottomButton from '../CardBottomButton';

export default function CardBottomButtons({ className, config }) {
  if (!config || config.length < 1) {
    return null;
  }
  return (
    <div className={className}>
      {config.map(buttonConfig => (
        <CardBottomButton key={`cbb - ${buttonConfig.label}`} {...buttonConfig} />
      ))}
    </div>
  );
}
